import axios from "axios";
import { getCacheV1 } from "./common";
let baseURL = import.meta.env.VITE_API_BASE_URL
  || (import.meta.env.DEV ? "https://teafarm.zeabur.app" : "https://in.sentry-dev.com");
const getToken = () => getCacheV1("token"); //获取token的方法
const service = axios.create({
  baseURL,
  timeout: 120 * 1000,
  headers: {
    "Content-Type": "application/json",
  },
});
service.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (errer) => {
    return Promise.reject(errer);
  },
);

/**
 * 使用实例：
 * POST:
 *      reqest("/api/get",{
 *              method:"POST",
 *              params:params
 *      })
 * GET:
 *      reqest("/api/get?data=data")
 *
 */
const Request = (url, options = {}) => {
  const method = (options.method || "get").toLowerCase();
  const params = options.params || {};
  const headers = options.headers || {};

  // GET: 参数放 query string
  if (method === "get") {
    return service.get(url, { params, headers }).then((res) => res.data);
  }

  // POST/PUT/PATCH/DELETE: 参数放 body
  return service
    .request({ url, method, data: params, headers })
    .then((res) => res.data);
};

export { Request };
